import { useEffect } from 'react';
import { getProgressOwner } from '../../../utils/session';
import { beginStep, endStep } from '../../../utils/stepTiming';
import { logEvent, setExerciseContext, clearExerciseContext } from '../../../utils/experimentLog';

// 演習ルート（Ex1_2026_Shape / Ex1_2026_Gaze）が問×ステップを開くたびに、
//   ・ログの文脈（演習・問・ステップ・モデル名）を切り替え、以後の記録に付ける
//   ・所要時間の計測をそのステップへ切り替える（utils/stepTiming.js。最初に開いた時刻から数える）
//   ・表示の記録（exercise_step_view）を送る
// active=false（完了画面）の間は計測を止めて文脈も外す。演習を離れたら（アンマウント）同じく止める
// （デモ画面などの操作に演習の問番号が付かないように）。
export function useExerciseStepLog({ exercise, index, stepsPerQuestion, modelMap, active = true }) {
  useEffect(() => {
    if (!active) {
      endStep();
      clearExerciseContext();
      return;
    }
    const qIdx = Math.floor(index / stepsPerQuestion);
    const glbPath = modelMap[qIdx] || 'model1';
    beginStep(getProgressOwner(), exercise, index);
    setExerciseContext({ exercise, questionNumber: qIdx + 1, step: (index % stepsPerQuestion) + 1, glbPath });
    logEvent('exercise_step_view', { questionNumber: qIdx + 1, glbPath, stepWithin: index % stepsPerQuestion });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [exercise, index, stepsPerQuestion, active]);

  useEffect(() => () => {
    endStep();
    clearExerciseContext();
  }, []);
}
